import { useState } from 'react';
import { Plus } from 'lucide-react';
import { faq } from '../../data/homepageData';

export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="section faq-section">
      <h2>Časté dotazy</h2>
      <div className="faq-grid">
        {faq.map((item, index) => (
          <div className="faq-item" key={item.q}>
            <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index}>
              <span>{item.q}</span>
              <Plus size={18} />
            </button>
            {open === index && <p>{item.a}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
